<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
// import DataTable from 'datatables.net-vue3';
import nonvoucher from "../report/nonvoucher";
import voucher from "../report/voucher";
import enquiry from "../report/enquiry";

export default {
  page: {
    // this.$route.query.company_name
    title: "Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
        role:localStorage.getItem('role'),
      title: "Report",
      items: [
        {
          text: "Report",
          active: true,
        },
      ],
        status:'',
        url_:'',
        company_name:'',
        refemail:'',
        startdate:'',
        enddate:'',
        country:'',
        types_report:'Non_Voucher',

      SearchData:[],
      statusData:[],
      countryData:[],
     apiType:'',
      LoadingSearch:false,
      isSearch:false,

      zulKey:0,

      staticURLDownload: process.env.VUE_APP_API_BASEURL+'report/excel?',
    };
  },

  methods: {

    searchbutton(){
        this.url_ = 'company_name='+ this.company_name + '&refemail='+this.refemail+ '&startdate='+this.startdate+ '&enddate='+this.enddate+ '&status='+this.status+ '&country='+this.country+ '&types_report='+this.types_report;
        this.$router.push('/report?'+this.url_); 
        this.search();
    },

    search(){
        this.LoadingSearch=true;
        this.isSearch=true;
        // e.preventDefault()

        const posting_ = { 
            company_name: this.company_name,
            refemail: this.refemail,
            startdate: this.startdate,
            enddate: this.enddate,
            status: this.status,
            country: this.country,
            types_report: this.types_report,
        };
        // console.log(posting_);
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.post(process.env.VUE_APP_API_BASEURL+'report', posting_)
        .then(responsea => {
            if (responsea) {
                this.SearchData=responsea.data.data;
                this.apiType=responsea.data.type;
                this.tokenGenerator=responsea.data.token;
                // console.log(this.SearchData);
                // console.log('==');
                this.LoadingSearch=false;
                this.isSearch=true;
                this.zulKey +=1;
                
            }
        });

    },
    listStatus(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'status')
        .then(response => {
            if (response) {
                this.statusData = response.data;
            } else {
                this.messageBag = ['No record.'];
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
        });
    },

    GetCountry(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'country')
        .then(response => {
        // console.log('xxxxxxx');
            if (response) {
                if(response.data.status=='error'){
                    // console.log('aaaaaaaaaa');
                    this.messageBag = response.data.msj;
                    this.countreload = true;
                }else{
                    // console.log(response.data);
                    this.countryData = response.data;
                    this.countreload = true;
                    
                }
                
            } else {
                // console.log('daddddd');
                this.messageBag = ['No record.'];
                this.countreload = true;
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
                this.countreload = true;
        });
    },

    clearbtn(){
        this.company_name='';
        this.refemail='';
        this.startdate='';
        this.enddate='';
        this.status='';
        this.country='';
    },
  },

 
  mounted (){

    if(this.role != 3){
        this.listStatus();
        this.GetCountry();
        if (typeof this.$route.query.company_name !== 'undefined') {
            this.company_name = this.$route.query.company_name;
        }

        if (typeof this.$route.query.refemail !== 'undefined') {
            this.refemail = this.$route.query.refemail;
        }

        if (typeof this.$route.query.startdate !== 'undefined') {
            this.startdate = this.$route.query.startdate;
        }

        if (typeof this.$route.query.enddate !== 'undefined') {
            this.enddate = this.$route.query.enddate;
        }

        if (typeof this.$route.query.status !== 'undefined') {
            this.status = this.$route.query.status;
        }

        if (typeof this.$route.query.types_report !== 'undefined') {
            this.types_report = this.$route.query.types_report;
        }

        

        if (typeof this.$route.query.country !== 'undefined') {
            this.country = this.$route.query.country;
            this.searchbutton();
        }

        
       
    }else{
        alert('You are not authorized to view the requested page!')
    }
  },
  components: {
    Layout,
    PageHeader,
    // DataTable,
    nonvoucher,
    voucher,
    enquiry,
  },
};
// require("@/assets/css/datatable.css");
</script>

<template>
  <Layout v-if="this.role != 3">
    <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <form @submit="search" id="search">
                                    <div class="row g-3">
                                        <div class="col-lg-6">
                                            <label for="roc" class="form-label">Report Type</label>
                                            <div  class="mb-3">
                                                <input type="radio" v-model="types_report" value="Non_Voucher"> Non Voucher
                                                <input type="radio" v-model="types_report" value="Voucher"> Voucher
                                                <input type="radio" v-model="types_report" value="Enquiry"> Enquiry
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                        </div>
                                        <div class="col-lg-6">
                                            <div>
                                                <label for="company_name" class="form-label">Company Name</label>
                                                <input type="text" v-model='company_name' class="form-control" id="company_name" placeholder="Apple Inc" required/>
                                            </div>
                                        </div>
                                        <!--end col-->
                                        <div class="col-lg-6">
                                            <label for="roc" class="form-label">Referral Email</label>
                                            <input type="text" class="form-control" id="refemail" v-model="refemail" placeholder="buah@apple.com" required/>
                                        </div>
                                        <div class="col-lg-6">
                                            <label for="roc" class="form-label">Start Date</label>
                                            <input type="date" class="form-control" id="startdate" v-model="startdate" placeholder="" required/>
                                        </div>
                                        <div class="col-lg-6">
                                            <label for="roc" class="form-label">End Date</label>
                                            <input type="date" class="form-control" id="enddate" v-model="enddate" placeholder="" required/>
                                        </div>

                                        <div class="col-lg-6">
                                            <label for="roc" class="form-label">Status</label>
                                            <span v-if='types_report =="Non_Voucher"|| types_report=="Voucher" '>
                                                <select v-model="status" class="form-select mb-3" arial-label="Default select example" required>
                                                    <option value="" >Select Status</option>
                                                    <option v-for="(item, index) in statusData" :key="index" :value="item.id" >
                                                        {{ item.name }}
                                                    </option>
                                                </select>
                                            </span>
                                            <span v-else>
                                                <select v-model="status" class="form-select mb-3" arial-label="Default select example" required>
                                                    <option value="" >Select Status</option>
                                                    <option value='9'>Pending</option>
                                                    <option value='3'>Close</option>
                                                    <option value='1'>Submit</option>
                                                </select>
                                            </span>
                                        </div>
                                        <div class="col-lg-6">
                                            <label for="roc" class="form-label">Country</label>
                                            <select v-model="country" class="form-select mb-3" arial-label="Default select example" >
                                                <option value="" >Select Country</option>
                                                <option v-for="(item, index) in countryData" :key="index" :value="item.id" >
                                                    {{ item.code }} - {{ item.country }}
                                                </option>
                                            </select>
                                        </div>
                                        
                                        <!--end col-->
                                        <div class="col-lg-6">
                                            <div class="row">
                                                <div class="col-lg-6">
                                                    <div class="live-preview">
                                                        <div class="d-grid gap-2">
                                                            <button class="btn btn-primary btn-md" type="button" block="" @click='searchbutton'><!---->
                                                                <div class="btn-content">Search</div>
                                                            </button>
                                                            
                                                        </div>
                                                    </div>
                                                    &nbsp;&nbsp;&nbsp;
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="live-preview">
                                                        <div class="d-grid gap-2">
                                                            <button class="btn btn-secondary btn-md" type="button" block="" @click='clearbtn'><!---->
                                                                <div class="btn-content">Clear</div>
                                                            </button>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!--end col-->
                                    </div>
                                    <!--end row-->
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row" v-if="apiType == 'nonvoucher'||apiType == 'voucher'||apiType == 'Enquiry'">
            <div class="col-lg-6">
                <a :href="staticURLDownload+url_+tokenGenerator" class="btn btn-primary custom-toggle" target="_blank">
                    <span class="icon-on"><i class="ri-file-excel-2-line align-bottom"></i> 
                    Download</span>
                </a> <br><br>
            </div>
        </div>
        <span v-if='apiType=="nonvoucher"'>
            <nonvoucher :SearchData="SearchData" :key='zulKey'></nonvoucher>
        </span>
        <span v-if='apiType=="voucher"'>
            <voucher :SearchData="SearchData" :key='zulKey'></voucher>
        </span>
        <span v-if='apiType=="Enquiry"'>
            <enquiry :SearchData="SearchData" :key='zulKey'></enquiry>
        </span>
            

    </Layout>
</template>